export default {
  header: {
    self: {},
    items: [
      {
        title: "Administrar",
        root: true,
        alignment: "left",
        toggle: "click",
        permission: 'administrador',
        submenu: [
          {
            title: "Status do sistema",
            page: "adm-status-sistema",
            permission: 'administrador.status-sistema',
          },
          {
            title: "Salas virtuais",
            page: "adm-salas",
            permission: 'administrador.salas',
          },
          {
            title: "Grupos locais",
            page: "adm-grupo-local",
            permission: 'administrador.grupolocal',
          },
          {
            title: "Usuários locais",
            page: "adm-usuario-local",
            permission: 'administrador.usuariolocal',
          },
          {
            title: "Gerenciar gravações",
            page: "adm-gerenciar-gravacoes",
            permission: 'administrador.gerenciar-gravacoes',
          },
          {
            title: "Logs de acesso",
            page: "adm-logs-acesso",
            permission: 'administrador.logs-acesso',
          },

        ]
      },
      {
        title: "Organizar",
        root: true,
        alignment: "left",
        toggle: "click",
        permission: 'organizador',
        submenu: [
          {
            title: "Nova sessão",
            page: "org-nova-sessao",
            permission: 'organizador.nova-sessao',
          },
          {
            title: "Gerenciar sessões",
            submenu: [
              {
                title: "Em andamento",
                page: "org-em-andamento",
                permission: 'organizador.gerenciar-sessoes.em-andamento',
              },
              {
                title: "Agendadas",
                page: "org-agendadas",
                permission: 'organizador.gerenciar-sessoes.agendadas',
              },
              {
                title: "Encerradas",
                page: "org-encerradas",
                permission: 'organizador.gerenciar-sessoes.encerradas',
              },
            ]
          }
        ]
      },
      {
        title: "Participar",
        root: true,
        alignment: "left",
        toggle: "click",
        permission: 'participante',
        submenu: [
          {
            title: "Em andamento",
            page: "part-em-andamento",
            permission: 'participante.em-andamento',
          },
          {
            title: "Agendadas",
            page: "part-agendadas",
            permission: 'participante.agendadas',
          },
          {
            title: "Encerradas",
            page: "part-encerradas",
            permission: 'participante.encerradas',
          },

        ]
      },
      {
        title: "Publicação",
        root: true,
        alignment: "left",
        permission: "publicacao",
        page: "publicacao"
      },
    ]
  },
  aside: {
    self: {},
    items: [
      {
        title: "Administrar",
        root: true,
        alignment: "left",
        toggle: "click",
        permission: 'administrador',
        submenu: [
          {
            title: "Status do sistema",
            page: "adm-status-sistema",
            permission: 'administrador.status-sistema',
          },
          {
            title: "Salas virtuais",
            page: "adm-salas",
            permission: 'administrador.salas',
          },
          {
            title: "Grupos locais",
            page: "adm-grupo-local",
            permission: 'administrador.grupolocal',
          },
          {
            title: "Usuários locais",
            page: "adm-usuario-local",
            permission: 'administrador.usuariolocal',
          },
          {
            title: "Gerenciar gravações",
            page: "adm-gerenciar-gravacoes",
            permission: 'administrador.gerenciar-gravacoes',
          },
          {
            title: "Logs de acesso",
            page: "adm-logs-acesso",
            permission: 'administrador.logs-acesso',
          },

        ]
      },
      {
        title: "Organizar",
        root: true,
        alignment: "left",
        toggle: "click",
        permission: 'organizador',
        submenu: [
          {
            title: "Nova sessão",
            page: "org-nova-sessao",
            permission: 'organizador.nova-sessao',
          },
          {
            title: "Gerenciar sessões",
            submenu: [
              {
                title: "Em andamento",
                page: "org-em-andamento",
                permission: 'organizador.gerenciar-sessoes.em-andamento',
              },
              {
                title: "Agendadas",
                page: "org-agendadas",
                permission: 'organizador.gerenciar-sessoes.agendadas',
              },
              {
                title: "Encerradas",
                page: "org-encerradas",
                permission: 'organizador.gerenciar-sessoes.encerradas',
              },
            ]
          }
        ]
      },
      {
        title: "Participar",
        root: true,
        alignment: "left",
        toggle: "click",
        permission: 'participante',
        submenu: [
          {
            title: "Em andamento",
            page: "part-em-andamento",
            permission: 'participante.em-andamento',
          },
          {
            title: "Agendadas",
            page: "part-agendadas",
            permission: 'participante.agendadas',
          },
          {
            title: "Encerradas",
            page: "part-encerradas",
            permission: 'participante.encerradas',
          },

        ]
      },
      {
        title: "Publicação",
        root: true,
        alignment: "left",
        permission: "publicacao",
        page: "publicacao"
      },
    ]
  }
};
